module.exports = __webpack_public_path__ + "img/B12-20190411_01.e564e9c6.jpg";